import React from 'react';
import { Fade, Typography } from '@mui/material';
import { TeacherItem, TeacherList } from '../types';
import TeacherCard from './teacher-card';
import { EventBus } from '@/shared/utils';
import { TeacherEventKeys, TeacherEvents } from '../events';
import { Teacher as TeacherDict } from '@/shared/i18n';
import Grid from '@mui/material/Grid2';

type TeacherListProps = {
  teachers?: TeacherList;
  teacher?: TeacherItem;
  dict: TeacherDict;
  eventBus: EventBus<TeacherEvents>;
};

const TeacherListComponent = ({ teachers, dict, eventBus }: TeacherListProps) => {
  const handleTeacherClick = (teacherId: string, displayName: string) => {
    // Emette l'evento teacher.view con l'id dell'insegnante
    eventBus.emit(TeacherEventKeys.teachers.doDetail, { id: teacherId, displayName });
  };
  return (
    <>
      <div className="text-center mb-10">
        <Typography variant="h1" component="h1" color="textPrimary" className="text-center mb-4">
          {dict.teacher.our_teachers}
        </Typography>
        <Typography variant="s1" color="textSecondary" component="h2">
          {dict.teacher.explore_teachers}
        </Typography>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-4 gap-2 text-center md:text-left">
          <Typography variant="h3" component="p">
            {dict.teacher.teacher_list}
          </Typography>
          <Typography variant="s1" component="p">
            {teachers?.length} {teachers?.length === 1 ? 'profilo' : 'profili'}
          </Typography>
        </div>

        {teachers?.length === 0 ? (
          <Fade in>
            <div className="h-[180px] md:h-[400px] w-full border border-[#414351] border-dotted rounded-xl flex flex-col justify-center items-center text-center relative overflow-hidden">
              <img
                className="hidden md:block absolute h-[320px] md:right-[-16%] md:rotate-[-10deg] lg:rotate-[0deg] lg:right-[24px] xl:right-[10%] opacity-50"
                src="/assets/images/placeholder/placeholder-no-item-dx.png"
                alt="Placeholder Right"
              />
              <img
                className="hidden md:block absolute h-[320px] opacity-50 md:left-[-16%] md:rotate-[10deg] lg:rotate-[0deg] lg:left-[24px] xl:left-[10%]"
                src="/assets/images/placeholder/placeholder-no-item-sx.png"
                alt="Placeholder Left"
              />
              <div className="mb-6">
                <img
                  className="h-[40px] md:h-[80px] mx-auto"
                  src="/assets/images/placeholder/search-content.svg"
                  alt="Search Icon"
                />
                <Typography variant="mac-sans-h4" className="opacity-30" component="p">
                  Nessun insegnante disponibile
                </Typography>
                <Typography variant="body-small-500" className="opacity-30" component="p">
                  Al momento la musica è in pausa… riprova più tardi!
                </Typography>
              </div>
            </div>
          </Fade>
        ) : (
          <Grid container spacing={2}>
            {teachers
              ?.slice()
              .sort((a, b) => a.displayName.localeCompare(b.displayName))
              .map((teacher, index) => (
                <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={index}>
                  <TeacherCard
                    className="max-w-[318px] mx-auto md:max-w-full"
                    name={teacher.displayName}
                    instruments={teacher.instruments}
                    imageUrl={teacher.imageUrl}
                    onClick={() => handleTeacherClick(teacher.id, teacher.displayName)}
                  />
                </Grid>
              ))}
          </Grid>
        )}
      </div>
    </>
  );
};

export default TeacherListComponent;
